<template>
  <v-col>
    <v-tabs>
      <v-tab>Product Search</v-tab>
      <v-tab>Custom Product Search</v-tab>
      <v-tab>Repair Search</v-tab>
      <v-tab-item>
        <product-search />
      </v-tab-item>
      <v-tab-item>
        <custom-search />
      </v-tab-item>
      <v-tab-item>
        <repair-search />
      </v-tab-item>
    </v-tabs>
  </v-col>
</template>

<script>
import CustomSearch from "./CustomSearch.vue";
import RepairSearch from "./RepairSearch.vue";
import ProductSearch from "./ProductSearch.vue";
export default {
  components: {
    "custom-search": CustomSearch,
    "repair-search": RepairSearch,
    "product-search": ProductSearch,
  },
};
</script>
